export const COMPANY_NAVIGATION_IDS = {
  SUMMARY: 'summary',
  FINANCIAL: 'financial',
  CAP_TABLE: 'captable',
  VALUATION: 'valuation',
  WATERFALL: 'waterfall',
  DOCUMENTS: 'documents',
  DOCUMENT_GENERATION_JOBS: 'document-generation-jobs',
} as const;

export const COMPANY_SECONDARY_NAVIGATION_LOADING_ARIA_LABEL = 'Loading company navigation';
